"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateInRange = exports.getNumberOfDaysInMonth = exports.getDayName = exports.getMonthName = exports.isDateValid = exports.getLocaleDateString = exports.getDateTimeFromDateParts = exports.getDateParts = exports.getToday = exports.ensureDateTime = exports.sortDatesByDateParts = exports.sortDates = exports.getDateFormat = exports.getMaxDate = exports.getMinDate = void 0;
const luxon_1 = require("luxon");
const utils_common_1 = require("@agilepoint/utils-common");
const minDate = new Date(1906, 0);
function getMinDate() {
    return minDate;
}
exports.getMinDate = getMinDate;
const maxDate = new Date(9999, 11, 31);
function getMaxDate() {
    return maxDate;
}
exports.getMaxDate = getMaxDate;
const SAMPLE_DATE_Time = luxon_1.DateTime.fromJSDate(new Date(2020, 11, 23));
exports.getDateFormat = utils_common_1.memoizeFunction((locale) => {
    const dateString = SAMPLE_DATE_Time.toLocaleString({ locale });
    return (dateString ? dateString.replace('12', 'MM').replace('2020', 'yyyy').replace('23', 'dd') : 'dd/MM/yyyy');
});
exports.sortDates = (selectedDates, format) => selectedDates.sort((date1, date2) => {
    const parsedDate1 = exports.ensureDateTime(date1, format);
    const parsedDate2 = exports.ensureDateTime(date2, format);
    return ((parsedDate1 < parsedDate2) ? -1 : (parsedDate1 > parsedDate2) ? 1 : 0);
});
exports.sortDatesByDateParts = (datePartsList) => datePartsList.sort((date1, date2) => {
    const parsedDate1 = getDateTimeFromDateParts(date1);
    const parsedDate2 = getDateTimeFromDateParts(date2);
    return ((parsedDate1 < parsedDate2) ? -1 : (parsedDate1 > parsedDate2) ? 1 : 0);
});
exports.ensureDateTime = utils_common_1.memoizeFunction((date, format) => {
    if (luxon_1.DateTime.isDateTime(date)) {
        return date;
    }
    if (utils_common_1.isDate(date)) {
        return luxon_1.DateTime.fromJSDate(date);
    }
    if (utils_common_1.isNumber(date)) {
        return luxon_1.DateTime.fromMillis(date);
    }
    return format ? luxon_1.DateTime.fromFormat(date, format) : luxon_1.DateTime.fromISO(date);
}, 100);
function getOnlyDate(date = new Date()) {
    return new Date(date.toDateString());
}
let _lastDate = null;
function getToday() {
    if (_lastDate === null) {
        _lastDate = getOnlyDate();
        return _lastDate;
    }
    const now = getOnlyDate();
    if (_lastDate.getDate() !== now.getDate()) {
        _lastDate = now;
    }
    return _lastDate;
}
exports.getToday = getToday;
exports.getDateParts = utils_common_1.memoizeFunction((date, format) => {
    const dateTime = exports.ensureDateTime(date, format);
    return {
        date: dateTime.day,
        month: dateTime.month,
        year: dateTime.year
    };
}, 100);
function getDateTimeFromDateParts(dateParts) {
    const { date, month = 1, year = 1991 } = dateParts;
    return luxon_1.DateTime.local(year, month, date);
}
exports.getDateTimeFromDateParts = getDateTimeFromDateParts;
function getLocaleDateString(date, format, locale) {
    let dateTime = exports.ensureDateTime(date);
    if (!format) {
        return dateTime.toLocaleString({ locale }) || '';
    }
    if (locale) {
        dateTime = dateTime.setLocale(locale);
    }
    return dateTime.toFormat(format);
}
exports.getLocaleDateString = getLocaleDateString;
function isDateValid(date, format) {
    const dateTime = exports.ensureDateTime(date, format);
    return dateTime.isValid;
}
exports.isDateValid = isDateValid;
exports.getMonthName = utils_common_1.memoizeFunction((month, length = 'long', locale) => {
    const months = luxon_1.Info.months(length, { locale });
    return months[month - 1] || '';
}, 100);
exports.getDayName = utils_common_1.memoizeFunction((day, length = 'short', locale) => {
    const weekDays = luxon_1.Info.weekdays(length, { locale });
    return weekDays[day - 1] || '';
}, 100);
exports.getNumberOfDaysInMonth = utils_common_1.memoizeFunction((month, year) => getDateTimeFromDateParts({ month, year }).daysInMonth, 100);
const ensureValidDate = (date, format) => ((date && isDateValid(date, format)) ? date : undefined);
function isDateInRange(date, minDate, maxDate, format) {
    var _a, _b;
    const parsedDate = exports.ensureDateTime(date, format);
    minDate = (_a = ensureValidDate(minDate, format)) !== null && _a !== void 0 ? _a : getMinDate();
    maxDate = (_b = ensureValidDate(maxDate, format)) !== null && _b !== void 0 ? _b : getMaxDate();
    return (parsedDate >= exports.ensureDateTime(minDate, format) && parsedDate <= exports.ensureDateTime(maxDate, format));
}
exports.isDateInRange = isDateInRange;
//# sourceMappingURL=date-time.js.map